import { PerformanceSummaryDirective, PerformanceSummaryDirectiveSID } from './directive';
import { PerformanceSummaryService } from './service';
import './moneyMetricFilter/index';
export { PerformanceSummaryDirective } from './directive';

angular.module('app').service(PerformanceSummaryService.SID, PerformanceSummaryService);
angular.module('app').directive(PerformanceSummaryDirectiveSID, [PerformanceSummaryDirective]);
